import './index.scss'
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { NavBar } from 'antd-mobile'
import { IRoute, routes } from '../../route'
import { HomeOutlined } from '@ant-design/icons'
import { fetchAdminDetail } from '../../api'

export default function Home() {
  const location = useLocation()
  const navigate = useNavigate()
  const admin = useSelector<any, any>(state => state.app.admin)
  const currentRoute = useMemo<IRoute | undefined>(
    () => routes.find(route => route.path === location.pathname),
    [location.pathname]
  )

  // 物业账号：不能使用管理端洗车免停/对账管理页，统一进入只读对账展示页
  useEffect(() => {
    const blocked = ['/free-park-list', '/free-park']
    if (!blocked.includes(location.pathname)) return
    fetchAdminDetail({}).then((res: any) => {
      if (res?.data?.type === 4) {
        navigate('/free-park-list-view', { replace: true })
      }
    })
  }, [location.pathname, navigate])

  if (!admin) {
    return <Navigate replace to="/login" />
  }

  const hideNavActions = currentRoute?.hideNavActions === true
  const hideNav = currentRoute?.hideNav === true

  if (hideNav) {
    return (
      <div className="home flex-column">
        <Outlet />
      </div>
    )
  }

  return (
    <div className="home flex-column">
      <NavBar
        className="nav flex-shrink"
        back={currentRoute?.path === '/nav' || hideNavActions ? null : '返回'}
        right={
          hideNavActions ? null : (
            <HomeOutlined style={{ fontSize: 20 }} onClick={() => navigate('/')} />
          )
        }
        style={{
          '--border-bottom': '1px #f1f1f1 solid'
        }}
        onBack={
          hideNavActions
            ? undefined
            : () => {
                try {
                  const state = location.state as { fromHome?: boolean; scrollTo?: string } | undefined
                  console.log('home页面状态', state)

                  if (state?.fromHome) {
                    navigate('/nav', {
                      state: {
                        scrollTo: state.scrollTo,
                        fromDetail: true,
                        _key: Date.now() // 每次返回生成唯一标识
                      },
                      replace: true // 使用replace避免历史记录堆积
                    })
                  } else {
                    navigate(-1)
                  }
                } catch (error) {
                  console.log(error)
                }
              }
        }
      >
        <span style={{ color: 'var(--adm-color-primary' }}>{currentRoute?.title}</span>
      </NavBar>
      <div className="">
        <Outlet />
      </div>
    </div>
  )
}
